(() => {
  const isCollection = () => location.pathname.startsWith("/collections/");
  if (!isCollection()) return;

  const GRID_ID = "products";
  const KEY_SNAP = "st_snap_to_grid_v1";

  // Optional: if you want chip-removal to instantly re-run results when you're currently at 0 results,
  // flip this to true. Otherwise users remove chips then press "Show results".
  const AUTO_APPLY_WHEN_NO_RESULTS = false;
  const pageHasNoResults = () => !!document.querySelector(".productgrid--no-results");

  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;
  const qs = (sel, root = document) => root.querySelector(sel);

  const snapToGrid = () => {
    const grid = document.getElementById(GRID_ID);
    if (!grid) return;
    const y = grid.getBoundingClientRect().top + window.scrollY - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: "auto" });
  };

  // ---- On load: snap to grid if flagged ----
  try {
    const raw = sessionStorage.getItem(KEY_SNAP);
    if (raw) {
      sessionStorage.removeItem(KEY_SNAP);
      requestAnimationFrame(() => snapToGrid());
    }
  } catch (_) {
    sessionStorage.removeItem(KEY_SNAP);
  }

  // ============================
  // MOBILE: staged filters modal
  // ============================

  const SINGLE_SELECT_PER_FILTER = false;

  let baseUrl = new URL(location.href);
  let pendingUrl = new URL(location.href);

  const getModalInner = () => qs('.modal-inner[data-modal-inner]');
  const getModalContent = () => qs('.modal-content[data-modal-content]');
  const modalOpen = () => !!getModalInner();

  const facetLinksIn = (root) =>
    Array.from(root.querySelectorAll('a.collection-filters__filter-link[data-name][data-value][data-filter-input]'));

  const setCheckmark = (a, checked) => {
    const svg = a.querySelector("svg.checkmark");
    if (!svg) return;
    const state = checked ? "checked" : "unchecked";
    svg.setAttribute("data-animation-state", state);
    svg.querySelectorAll("[data-animation-state]").forEach((n) => n.setAttribute("data-animation-state", state));
  };

  const clearAllURL = (u) => {
    const next = new URL(u.pathname, u.origin);
    ["grid_list", "sort_by", "q"].forEach((k) => {
      if (u.searchParams.has(k)) next.searchParams.set(k, u.searchParams.get(k));
    });
    return next;
  };

  const buildFacetURL = (u, name, value) => {
    const cur = new URL(u.toString());
    cur.searchParams.delete("page");

    const activeValues = cur.searchParams.getAll(name);
    const isActive = activeValues.includes(value);

    if (!SINGLE_SELECT_PER_FILTER) {
      if (isActive) {
        const entries = Array.from(cur.searchParams.entries());
        cur.search = "";
        let removed = false;
        for (const [k, v] of entries) {
          if (!removed && k === name && v === value) {
            removed = true;
            continue;
          }
          cur.searchParams.append(k, v);
        }
      } else {
        cur.searchParams.append(name, value);
      }
      return cur;
    }

    const entries = Array.from(cur.searchParams.entries());
    cur.search = "";
    for (const [k, v] of entries) {
      if (k === name) continue;
      cur.searchParams.append(k, v);
    }
    if (!isActive) cur.searchParams.append(name, value);
    return cur;
  };

  const getChipsWrap = (modal) =>
    modal.querySelector("[data-facets-chips-host]") || modal.querySelector(".productgrid--filters--mobile");

  const syncModalUI = () => {
    const modal = getModalContent();
    if (!modal) return;

    // update facet checkmarks + hrefs to reflect pendingUrl
    facetLinksIn(modal).forEach((a) => {
      const name = a.getAttribute("data-name");
      const value = a.getAttribute("data-value");
      if (!name) return;

      const isActive = pendingUrl.searchParams.getAll(name).includes(value);

      const li = a.closest(".collection-filters__filter-list-item");
      if (li) {
        li.classList.toggle("collection-filters__filter-list-item--active", isActive);
        li.setAttribute("data-filter-open", isActive ? "true" : "false");
      }

      setCheckmark(a, isActive);

      const next = buildFacetURL(pendingUrl, name, value);
      a.setAttribute("href", next.pathname + next.search);
    });

    // chips inside modal
    const chipsWrap = getChipsWrap(modal);
    if (!chipsWrap) return;

    let ul = chipsWrap.querySelector("ul.active-filter-group");
    if (!ul) {
      ul = document.createElement("ul");
      ul.className = "active-filter-group";
      chipsWrap.appendChild(ul);
    }

    const activePairs = [];
    for (const [k, v] of pendingUrl.searchParams.entries()) {
      if (k.startsWith("filter.")) activePairs.push([k, v]);
    }

    ul.innerHTML = "";

    if (activePairs.length) {
      for (const [name, value] of activePairs) {
        const li = document.createElement("li");
        li.className = "active-filter-group__item-wrapper";

        const a = document.createElement("a");
        a.className = "active-filter-group__item";
        a.setAttribute("data-filter-input", "");

        const removeUrl = buildFacetURL(pendingUrl, name, value);
        a.href = removeUrl.pathname + removeUrl.search;

        const label =
          facetLinksIn(modal)
            .find((x) => x.getAttribute("data-name") === name && x.getAttribute("data-value") === value)
            ?.textContent?.replace(/\(\s*\d+\s*\)/g, "")
            .trim() || value;

        a.innerHTML =
          `<span class="active-filter-text">${label}</span>` +
          `<span class="filter-icon--remove"><span aria-hidden="true">×</span></span>`;

        li.appendChild(a);
        ul.appendChild(li);
      }

      const liClear = document.createElement("li");
      liClear.className = "active-filter-group--remove-all filter-item--grid-simple";

      const aClear = document.createElement("a");
      aClear.className = "filter-item-clear-all";
      const cleared = clearAllURL(pendingUrl);
      aClear.href = cleared.pathname + cleared.search;
      aClear.textContent = "Clear all";

      liClear.appendChild(aClear);
      ul.appendChild(liClear);

      chipsWrap.style.display = "";
    } else {
      chipsWrap.style.display = "none";
    }
  };

  // When opening the mobile filter modal, init staged state
  document.addEventListener(
    "click",
    (e) => {
      if (!isMobile()) return;
      const btn = e.target?.closest?.("[data-productgrid-trigger-filters], .utils-filter-button");
      if (!(btn instanceof HTMLElement)) return;

      baseUrl = new URL(location.href);
      pendingUrl = new URL(location.href);

      setTimeout(() => {
        if (modalOpen()) syncModalUI();
      }, 60);
    },
    true
  );

  // Intercept facet/chip clicks inside modal only
  document.addEventListener(
    "click",
    (e) => {
      if (!isMobile() || !modalOpen()) return;

      const modal = getModalContent();
      if (!modal) return;

      const a = e.target?.closest?.("a");
      if (!(a instanceof HTMLAnchorElement)) return;
      if (!modal.contains(a)) return;

      // Facet option click (staged)
      if (
        a.classList.contains("collection-filters__filter-link") &&
        a.hasAttribute("data-name") &&
        a.hasAttribute("data-value")
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const name = a.getAttribute("data-name");
        const value = a.getAttribute("data-value");
        if (!name || value == null) return;

        pendingUrl = buildFacetURL(pendingUrl, name, value);
        syncModalUI();
        return;
      }

      // Chip remove (works for BOTH liquid-rendered and JS-rendered chips)
      if (a.classList.contains("active-filter-group__item")) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Use the chip's href directly (most reliable, handles encoding perfectly)
        pendingUrl = new URL(a.href, location.origin);
        pendingUrl.searchParams.delete("page");

        syncModalUI();

        if (AUTO_APPLY_WHEN_NO_RESULTS && pageHasNoResults()) {
          sessionStorage.setItem(KEY_SNAP, "1");
          location.href = pendingUrl.toString();
        }
        return;
      }

      // Clear all (use href)
      if (a.classList.contains("filter-item-clear-all")) {
        e.preventDefault();
        e.stopImmediatePropagation();

        pendingUrl = new URL(a.href, location.origin);
        pendingUrl.searchParams.delete("page");

        syncModalUI();

        if (AUTO_APPLY_WHEN_NO_RESULTS && pageHasNoResults()) {
          sessionStorage.setItem(KEY_SNAP, "1");
          location.href = pendingUrl.toString();
        }
        return;
      }
    },
    true
  );

  // Apply: navigate once + snap to grid after reload
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target?.closest?.(".filters-modal-apply");
      if (!(btn instanceof HTMLButtonElement)) return;

      if (pendingUrl.toString() === baseUrl.toString()) return;

      sessionStorage.setItem(KEY_SNAP, "1");
      setTimeout(() => {
        location.href = pendingUrl.toString();
      }, 80);
    },
    true
  );

  // ============================
  // DESKTOP: snap-to-grid on filter/pagination/sort clicks
  // ============================
  document.addEventListener(
    "click",
    (e) => {
      if (isMobile()) return;

      const a = e.target?.closest?.("a[href]");
      if (!(a instanceof HTMLAnchorElement)) return;

      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname !== location.pathname) return;

      const looksRelevant =
        url.search !== location.search &&
        (url.search.includes("filter.") ||
          url.searchParams.has("page") ||
          url.searchParams.has("sort_by") ||
          url.searchParams.has("grid_list") ||
          a.hasAttribute("data-filter-input"));

      if (!looksRelevant) return;

      sessionStorage.setItem(KEY_SNAP, "1");
    },
    true
  );
})();
